import useStyles from '../../../../../style/js-style/containers/administration/calculator/CalculatorDialogStyle';
import { useFieldArray, useFormContext } from 'react-hook-form';
import React, { useCallback, useEffect } from 'react';
import {
  CalculationResultType,
  getBranchModel,
} from '../../../../../services/common/CalculatorUtils';
import _ from 'lodash';
import EAIcon from '../../../../../components/common/EAIcon';
import i18next from 'i18next';
import DefaultPresentation from './DefaultPresentation';
import StandardPresentation from './StandardPresentation';

const Branches = ({ fieldName, resultType, readOnly = false }) => {
  const { classes } = useStyles();

  const formMethods = useFormContext();

  const { fields: branches, append, remove } = useFieldArray({
    control: formMethods.control,
    name: `${fieldName}`,
  });

  const onAddEntry = useCallback(() => {
    append(getBranchModel());
  }, [append]);

  const onRemoveEntry = useCallback(
    (index) => {
      remove(index);
    },
    [remove]
  );

  // En cas de suppression de la seule branche disponible on en recrée une vide
  useEffect(() => {
    if (
      CalculationResultType.ARITHMETIC_FORMULA_OUTPUT !== resultType &&
      _.size(_.filter(branches, { default: false })) < 1
    ) {
      onAddEntry();
    }
  }, [resultType, branches, onAddEntry]);

  return (
    <>
      <div className={classes.declarationBranchTitleWrapper}>
        <EAIcon icon="calculator/calculate" />
        <span className={classes.declarationBranchTitle}>
          {i18next.t('calculator.dialog.create.branches')}
        </span>
      </div>

      <div className={classes.declarationBranch}>
        {branches?.map((branch, index) => {
          if (branch.default) {
            return (
              <DefaultPresentation
                key={`branch-${branch.id}`}
                data={branch}
                fieldName={`${fieldName}.0`}
                resultType={resultType}
                readOnly={readOnly}
              />
            );
          } else {
            return (
              <StandardPresentation
                key={`branch-${branch.id}`}
                index={index}
                data={branch}
                fieldName={`${fieldName}.${index}`}
                onRemove={() => onRemoveEntry(index)}
                resultType={resultType}
                readOnly={readOnly}
              />
            );
          }
        })}
      </div>

      {!readOnly &&
        <div
          className={classes.declarationBranchAdd}
          onClick={() => onAddEntry()}
        >
          + {i18next.t('calculator.dialog.create.addBranch')}
        </div>
      }
    </>
  );
};

export default Branches;
